/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageBindingResponse
 */
export interface StorageBindingResponse {
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    purpose?: StorageBindingResponsePurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    storageAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    storageAccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof StorageBindingResponse
     */
    integrationInstanceId?: string;
    /**
     * 
     * @type {Date}
     * @memberof StorageBindingResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StorageBindingResponse
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof StorageBindingResponse
     */
    _default?: boolean;
}


/**
 * @export
 */
export const StorageBindingResponsePurposeEnum = {
    IntegrationPipeline: 'INTEGRATION_PIPELINE',
    SecureFiles: 'SECURE_FILES'
} as const;
export type StorageBindingResponsePurposeEnum = typeof StorageBindingResponsePurposeEnum[keyof typeof StorageBindingResponsePurposeEnum];


/**
 * Check if a given object implements the StorageBindingResponse interface.
 */
export function instanceOfStorageBindingResponse(value: object): value is StorageBindingResponse {
    return true;
}

export function StorageBindingResponseFromJSON(json: any): StorageBindingResponse {
    return StorageBindingResponseFromJSONTyped(json, false);
}

export function StorageBindingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageBindingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'storageAccountId': json['storageAccountId'] == null ? undefined : json['storageAccountId'],
        'storageAccountName': json['storageAccountName'] == null ? undefined : json['storageAccountName'],
        'integrationInstanceId': json['integrationInstanceId'] == null ? undefined : json['integrationInstanceId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function StorageBindingResponseToJSON(json: any): StorageBindingResponse {
    return StorageBindingResponseToJSONTyped(json, false);
}

export function StorageBindingResponseToJSONTyped(value?: StorageBindingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'purpose': value['purpose'],
        'storageAccountId': value['storageAccountId'],
        'storageAccountName': value['storageAccountName'],
        'integrationInstanceId': value['integrationInstanceId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'default': value['_default'],
    };
}

